export const b64ToBlob = (b64: string, type = 'application/pdf') => {
  const bin = atob(b64);
  const bytes = Uint8Array.from(bin, (c) => c.charCodeAt(0));
  return new Blob([bytes], { type });
};
